import { countryCodes, PH_SOCIAL_MEDIAS, SOCIAL_MEDIA_TYPE, TH_SOCIAL_MEDIAS } from "src/main/contants";
import {
  AppConfiguration,
  CountryCurrency,
  CountryEnvKey,
  DefaultLanguage,
  DeployCountry,
  DeployEnv,
} from "src/main/types";

const MAIN_SITES: Record<DeployCountry, string> = {
  [DeployCountry.TH]: "ilovevip.com",
  [DeployCountry.PH]: "ilovevip.org",
};

// APPLICATION CONFIGURATION
const appConfig: AppConfiguration<DeployCountry, DefaultLanguage, DeployEnv> = {
  domains: [
    // TH DOMAINS
    // TH main domains
    {
      domain: MAIN_SITES.th,
      country: DeployCountry.TH,
      isMain: true,
      env: DeployEnv.Production,
    },
    {
      domain: "ilvth.com",
      country: DeployCountry.TH,
      isMain: true,
      env: DeployEnv.Production,
    },
    {
      domain: "ilvth1.com",
      country: DeployCountry.TH,
      isMain: true,
      env: DeployEnv.Production,
    },
    {
      domain: "ilvth2.com",
      country: DeployCountry.TH,
      isMain: true,
      env: DeployEnv.Production,
    },
    {
      domain: "ilvth3.com",
      country: DeployCountry.TH,
      isMain: true,
      env: DeployEnv.Production,
    },
    // TH brand domains
    {
      domain: "wow99vip.com",
      brand: "wow99",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "xo666vip.com",
      brand: "xo666",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "dee99vip.com",
      brand: "dee99",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "big666vip.com",
      brand: "big666",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "boom88vip.com",
      brand: "boom88",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "good777vip.com",
      brand: "good777",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "moo555vip.com",
      brand: "moo555",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "wint9vip.com",
      brand: "wint8",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "xogovip.com",
      brand: "xogo",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "chaiyo268vip.com",
      brand: "chaiyo268",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "kbk99vip.com",
      brand: "kbk99",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "wow268vip.com",
      brand: "wow268",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "kbk99vipp.com",
      brand: "kbk99",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "moo555vipp.com",
      brand: "moo555",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "chaiyo268vipp.com",
      brand: "chaiyo268",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "wow268vipp.com",
      brand: "wow268",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "big666vipp.com",
      brand: "big666",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },
    {
      domain: "go989vvip.com",
      brand: "go989",
      country: DeployCountry.TH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.th,
    },

    // PH DOMAINS
    // PH main domains
    {
      domain: MAIN_SITES.ph,
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      isMain: true,
    },
    {
      domain: "ilovevipph.com",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      isMain: true,
    },
    {
      domain: "ilvph.com",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      isMain: true,
    },
    {
      domain: "ilvph1.com",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      isMain: true,
    },
    {
      domain: "ilvph2.com",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      isMain: true,
    },
    {
      domain: "ilvph3.com",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      isMain: true,
    },
    // PH brand domains
    {
      domain: "winhqvip.com",
      brand: "winhq",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.ph,
    },
    {
      domain: "ezjilivip.com",
      brand: "ezjili",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.ph,
    },
    {
      domain: "xojilivip.com",
      brand: "xojili",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.ph,
    },
    {
      domain: "wowjilivip.com",
      brand: "wowjili",
      country: DeployCountry.PH,

      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.ph,
    },
    {
      domain: "winhqvipp.com",
      brand: "winhq",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.ph,
    },
    {
      domain: "ezjilivipp.com",
      brand: "ezjili",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.ph,
    },
    {
      domain: "xojilivipp.com",
      brand: "xojili",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.ph,
    },
    {
      domain: "wowjilivipp.com",
      brand: "wowjili",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.ph,
    },
    {
      domain: "ezjiliilvph.com",
      brand: "ezjili",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.ph,
    },
    {
      domain: "xojiliilvph.com",
      brand: "xojili",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.ph,
    },
    {
      domain: "winhqilvph.com",
      brand: "winhq",
      country: DeployCountry.PH,
      env: DeployEnv.Production,
      mainUrl: MAIN_SITES.ph,
    },
    // STAGING DOMAINS
    {
      domain: "staging-member.ilovevip.com",
      country: DeployCountry.TH,
      env: DeployEnv.Staging,
      isMain: true,
      // Override country configuration
      countryConfig: {
        language: DefaultLanguage.EN,
      },
    },
    // LOCAL DOMAINS
    {
      domain: "localhost",
      country: (process.env.REACT_APP_COUNTRY_ISO as DeployCountry) ?? DeployCountry.TH,
      env: DeployEnv.Local,
      isMain: !process.env.REACT_APP_BRAND,
      brand: process.env.REACT_APP_BRAND,
      mainUrl: process.env.REACT_APP_MAIN_URL || "http://localhost:3000/",
      // Override country configuration
      countryConfig: {
        language: DefaultLanguage.EN,
        currency: process.env.REACT_APP_CURRENCY as CountryCurrency,
      },
    },
  ],
  // Common configurations for all countries
  countries: {
    [DeployCountry.TH]: {
      accountId: process.env.REACT_APP_TH_ACCOUNT_ID || "",
      language: DefaultLanguage.TH,
      phoneCode: countryCodes.TH,
      envKey: CountryEnvKey.TH,
      isoCode: DeployCountry.TH,
      currency: CountryCurrency.TH,
      contactPlatforms: [{ type: SOCIAL_MEDIA_TYPE.LINE, url: TH_SOCIAL_MEDIAS.LINE, title: "Line" }],
    },
    [DeployCountry.PH]: {
      accountId: process.env.REACT_APP_PH_ACCOUNT_ID || "",
      language: DefaultLanguage.EN,
      phoneCode: countryCodes.PH,
      envKey: CountryEnvKey.PH,
      isoCode: DeployCountry.PH,
      currency: CountryCurrency.PH,
      contactPlatforms: [
        {
          type: SOCIAL_MEDIA_TYPE.Messenger,
          url: PH_SOCIAL_MEDIAS.Messenger,
          title: "Messenger",
        },
        {
          type: SOCIAL_MEDIA_TYPE.Telegram,
          url: PH_SOCIAL_MEDIAS.Telegram,
          title: "Telegram",
        },
      ],
    },
  },
  server: {
    baseURL: process.env.REACT_APP_BASE_URL ?? "",
  },
};

export default appConfig;
